import React, {useState, useContext} from "react";
import {LoadComponet} from "../../../components/loaders/Loader";
import Table from "../../../components/table/Tables";
import {BodyDropDown, ItemStyled} from "../../../styles/ContentViews";
import ShowFacilitatorModal from "./ShowFacilitatorModal";
import {FacilitatorsContext} from "../../../context/FacilitatorsProvider";
import DeleteModal from "../../../components/modals/DeleteModal";
import ApiUrl from "../../../services/ApiUrl";
import {DeleteFacilitatorService} from "../../../services/FacilitatorsService";
import EditFacilitatorModal from "./EditModal";

export default function TableFacilitators({isLoading, data, theme}) {
   const [showModal, setShowModal] = useState({isOpen: false, data: {}});
   const [editModal, setEditModal] = useState({isOpen: false, data: {}});
   const [deleteModal, setDeleteModal] = useState({isOpen: false, id: ""});
   const {toggleChange} = useContext(FacilitatorsContext);

   const delteFac = () => {
      // console.log("Se elimino", id);
      let dat = {
         idFacilitator: deleteModal.id,
         isActive: false,
      };
      DeleteFacilitatorService(dat)
         .then((res) => res.json()) 
         .then((resp) => console.log(resp));
   };

   return (
      <>
         <BodyDropDown>
            <ItemStyled>
               {isLoading ? (
                  <LoadComponet isVisible={true} />
               ) : (
                  <Table
                     theme={theme}
                     columns={Columns}
                     data={data}
                     toggleChange={toggleChange}
                     deleteModal={(fac) => {
                        setDeleteModal({isOpen: true, id: fac.idFacilitator});
                     }}
                     showModal={(fac) => {
                        let info = data.find((item) => item.idFacilitator === fac.idFacilitator);
                        setShowModal({isOpen: true, data: info, type: "info", title: "Información De curso esencial"});
                     }}
                     editModal={(fac) => {
                        let info = data.find((item) => item.idFacilitator === fac.idFacilitator);
                        setEditModal({isOpen: true, data: info, type: "info", title: "Información De curso esencial"});
                     }}
                  />
               )}
            </ItemStyled>
         </BodyDropDown>
         <ShowFacilitatorModal
            isOpen={showModal.isOpen}
            close={() => {
               setShowModal({isOpen: false, data: {}});
            }}
            theme={theme}
            data={showModal.data}
         />
         <EditFacilitatorModal
            isOpen={editModal.isOpen}
            close={() => {
               setEditModal({isOpen: false, data: {}});
            }}
            theme={theme}
            data={editModal.data}
         />
         <DeleteModal
            isOpen={deleteModal.isOpen}
            close={() => {
               setDeleteModal({isOpen: false, id: ""});
            }}
            theme={theme}
            confirm={delteFac}
         />
      </>
   );
}

const Columns = [
   {
      title: "Nombre",
      action: "show",
      accessor: "name",
   },
   {
      title: "Teléfono",
      accessor: "phone",
   },
   {
      title: "",
      class: "clean",
      width: "240px",
      component: "",
      accessor: "",
   },
   {
      title: "Añadir a Página",
      class: "actionBtn ghost",
      component: "toggle",
      accessor: "addToWeb",
   },

   {
      title: "",
      class: "actionBtn ghost",
      component: "edit",
   },
   {
      title: "",
      class: "actionBtn ghost",
      component: "delete",
   },
];
